import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as smsActions from '../actions/sms-blast.action';
import {map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {SmsBlastService} from '../../sms-blast/sms-blast.service';

@Injectable()
export class SmsBlastEffects {
  constructor(private actions: Actions, private smsBlastService: SmsBlastService) {
  }

  @Effect()
  sendSMS: Observable<Action> = this.actions.ofType(smsActions.ADD_SMS)
    .map((action: smsActions.AddSms) => action.payload)
    .pipe(
      switchMap((payload) => {
        return this.smsBlastService.sendSMS(payload)
          .map(res => new smsActions.AddSmsSuccess(res))
          .catch(error => of(new smsActions.AddSmsError(error)));
      })
    );
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/store/effects/sms-blast.effects.ts